import type { DashboardFlags } from "../../../utils/billing-shared";
import { useAuth } from "../contexts/AuthContext";
import { useUsage } from "../contexts/UsageContext";

export type InterestSource = "billing_page" | "devices_page" | "add_device_dialog" | "devices_empty_state";

/**
 * Link to one of the interest Tally forms behind a dashboard fake door, prefilled through the
 * form's hidden fields so answers can be matched to the account and to the door that sent them.
 * Null while the door's dashboard flag is off.
 */
export function useInterestForm(
    flag: keyof DashboardFlags,
    formUrl: string,
    source: InterestSource,
): {
    href: string;
    plan: string;
} | null {
    const { user } = useAuth();
    const { usage, dashboardFlags } = useUsage();
    if (!dashboardFlags[flag]) {
        return null;
    }
    const plan = usage?.plan ?? "unknown";
    const url = new URL(formUrl);
    if (user?.email) {
        url.searchParams.set("email", user.email);
    }
    if (user?.id) {
        url.searchParams.set("user_id", user.id);
    }
    url.searchParams.set("plan", plan);
    url.searchParams.set("source", source);
    return {
        href: url.toString(),
        plan,
    };
}
